export default __webpack_public_path__ + "static/img/topBorder.6fb219b.png";